import { groupBy } from "meta/utils/groupBy";
import client from "./client";
export const fetchNotifications = async () => {
    const { data } = await client.getNotificationDetails();
    await new Promise((resolve) => {
        setInterval(() => resolve(null), 3000);
    });
    if (!data.SubitemsData) {
        return {};
    }
    const grouped = Object.entries(groupBy(data.Subitems, "NfgID"))
        .filter((x) => x[1].find((x) => data.AllowedCategories.includes(x.NfcCode)))
        .map(([, value]) => ({
        id: value[0].NfgID,
        name: value[0].NfgName,
        icon: value[0].NfgIcon,
        iconSet: value[0].NfgIconsSet,
        color: value[0].NfgTextColor,
        active: value[0].Active,
        background: value[0].NfgBackgroundColor,
        order: value[0].NfgOrder,
        count: getTotalCount(value, data),
    }))
        .filter((x) => x.active && x.name)
        .sort((a, b) => (a.order > b.order ? -1 : 1));
    const directNotifications = Object.entries(data.DirectNotifications)
        .filter((x) => data.AllowedCategories.includes(x[1].NfcCode))
        .map(([, value]) => ({
        description: value.NfsDescription,
        icon: value.NfsIcon,
        iconSet: value.NfsIconsSet,
        order: value.NfsOrder,
        count: getFormatedCount(data.SubitemsData[value.NfsCode]?.count || 0),
        color: value.NfsIconCounterTextColor,
        background: value.NfsIconCounterBackgroundColor,
        url: data.SubitemsData[value.NfsCode]?.url,
        title: data.SubitemsData[value.NfsCode]?.title,
        accessRestricted: data.SubitemsData[value.NfsCode]?.accessRestricted,
    }));
    return { grouped, directNotifications };
};
const getTotalCount = (value, data) => {
    const count = value.reduce((total, current) => total + (data.SubitemsData[current.NfsCode]?.count || 0), 0);
    return getFormatedCount(count);
};
const getFormatedCount = (count) => count > 99 ? "99+" : count.toString();
